(function(module) {
    'use strict';

    function appTileImageCtrl(envService, $timeout, $scope) {
        this.$onInit = () => {
            this.baseUrl = envService.read('APPS_URI');
            if (_.get(this, 'styles.thumbnail') && _.get(this, 'slug')) {
                const thumbnailUrl = `${this.baseUrl}/${this.slug}/thumbnail.jpg`;
                _.set(this, 'styles.image', thumbnailUrl);
                if (!$scope.$$phase) {
                    $timeout(() => {
                        $scope.$apply();
                    });
                }
            }
        };
    }

    module
        .component('appTileImage', {
            templateUrl: '/js/components/app-tile-image/app-tile-image.html',
            controller: appTileImageCtrl,
            bindings: {
                slug: '@',
                styles: '<',
                showPreview: '<',
                hoverText: '@',
                showLogo: '<',
                beta: '<',

            },
        });
})(angular.module('rocket.components'));
